module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white content-padded content-center form-icon-tip"
  }, [_vm._v("\n  该模板暂不需要配置\n")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-261319a1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-261319a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/template/mall/community_management.vue
// module id = 2549
// module chunks = 0